import { ReportTask } from './report-task.interface';

/**
 * The loaded list plus the runs started in this session that it does not
 * know yet, all newest first. A started run appears before the list knows
 * it; once the list has it, the loaded copy wins, because it carries the
 * final milestone when a push was missed (#5248).
 */
export function mergeReportTasks(
  started: readonly ReportTask[],
  loaded: readonly ReportTask[],
): ReportTask[] {
  const loadedUIds = new Set(loaded.map((task) => task.uId));
  const notLoadedYet = started.filter((task) => !loadedUIds.has(task.uId));
  return [...notLoadedYet, ...loaded].sort(byCreatedDesc);
}

function byCreatedDesc(a: ReportTask, b: ReportTask): number {
  return (b.created ?? '').localeCompare(a.created ?? '');
}
